module.exports = __webpack_public_path__ + "static/media/img3-1.3271663f.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/nogal/nutricheck_foliar/FE/img3-1.png
// module id = 1927
// module chunks = 3